import { useQuery } from '@apollo/client/react';
import { MainView } from '@repo/ui/Views';
import SettingsTabNav from '../components/SettingsTabNav';
import ChangePasswordForm from '../components/ChangePasswordForm';
import { MfaSettings, UserAuthProfile } from '@repo/auth/components/MfaSettings';
import { Dialog } from '@repo/ui/Dialog';
import { Button } from '@repo/ui/Button';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@repo/ui/InputOTP';
import QRCode from 'react-qr-code';

import ME_Q from '@/gql/me.gql';

interface UserWithMfa {
  id: string;
  email?: string;
  authProfile?: UserAuthProfile;
}

// Simple text input for phone number (outside form context)
function SimpleTextInput({
  label,
  placeholder,
  value,
  onChange,
  disabled,
  type = 'text',
}: {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  type?: string;
}) {
  return (
    <div className="flex flex-col gap-2 w-full">
      {label && (
        <label className="text-sm font-medium text-grey-700 dark:text-grey-300">{label}</label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="relative p-2 w-full rounded-md border bg-grey-100 border-grey-500 placeholder:text-grey-500 text-grey-1000 dark:text-blue-100 dark:placeholder:text-grey-400 dark:bg-blue-900 dark:border-grey-600 focus:border-blue-500 dark:focus:border-blue-300 focus:outline-none disabled:bg-grey-300"
      />
    </div>
  );
}

const Security = () => {
  const { data, refetch } = useQuery(ME_Q);
  const user = data?.user as UserWithMfa | undefined;

  return (
    <MainView title="Security">
      <SettingsTabNav />
      {user ? (
        <div className="flex flex-col gap-6">
          <ChangePasswordForm userId={user.id} />

          <MfaSettings
            authProfile={user.authProfile}
            userEmail={user.email ?? ''}
            onRefetch={refetch}
            DialogComponent={Dialog}
            ButtonComponent={Button}
            InputOTPComponent={InputOTP}
            InputOTPGroupComponent={InputOTPGroup}
            InputOTPSlotComponent={InputOTPSlot}
            QRCodeComponent={QRCode}
            TextInputComponent={SimpleTextInput}
          />
        </div>
      ) : null}
    </MainView>
  );
};

export default Security;
